import { useDispatch, useSelector } from "react-redux";
import { callAPI } from "../feature/APISlice.js";
import { openForm } from "../feature/formSlice.js";
import AdminNavbar from "./AdminNavbar.js";
import { useEffect } from "react";
import AboutUsMissionAndVisionForm from '../Form/AboutUsMissionAndVisionForm.js'

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/about-us-mission-vision`;

export default function AboutUsMissionAndVision() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((state) => state.api);

  
  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  
  const handleAddNew = () => {
    dispatch(openForm(null));
  };

  const handleEdit = (id) => {
    dispatch(openForm(id));
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      dispatch(
        callAPI({
          method: "delete",
          url: `${BASE_URL}/${id}`,
          data: { id },
        })
      );
    }
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleString() : "N/A";

  
  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <button className="admin-btn outline" onClick={handleAddNew}>
            + Add Mission / Vision
          </button>
        </div>

        {loading && <p>Loading data...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.length > 0 ? (
            items.map((item) => (
              <div className="admin-card" key={item.id}>
                
                <div className="admin-card-header">
                  <h4 className="admin-card-title">
                    {item.title || "No Title"}
                  </h4>
                </div>

                
                <p className="admin-card-status">
                  Status:{" "}
                  {item.is_active ? " Active" : "❌ Inactive"}
                </p>

                
                <div className="admin-card-info">
                  <p>
                    Created By:{" "}
                    <strong>{item.createdByName || "Unknown"}</strong>
                  </p>
                  <p>Created Time: {formatDate(item.createdTime)}</p>
                  <p>
                    Updated By:{" "}
                    <strong>
                      {item.lastModifiedByName || "Unknown"}
                    </strong>
                  </p>
                  <p>Updated Time: {formatDate(item.updatedTime)}</p>
                </div>

                
                <div className="admin-card-actions">
                  <button
                    className="admin-card-btn"
                    aria-label="Edit"
                    onClick={() => handleEdit(item.id)}
                  >
                    ✏️
                  </button>

                  <button
                    className="admin-card-btn"
                    aria-label="Delete"
                    onClick={() => handleDelete(item.id)}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))
          ) : (
            !loading && <p>No items found.</p>
          )}
        </div>
      </div>

      <AboutUsMissionAndVisionForm />
    </div>
  );
}
